<div class=" banner_header">
    <div class="col-md-12">
        <h2>FAQ</h2>
    </div>
</div>

<div class="container download_section">
    <!-- <div class="row ">
        <div class="col-md-12">
            <h3>Exam Related</h3>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <button class="accordion">Step 1           <i (click)="down_arr()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name" aria-hidden="true"></i> <i (click)="up_arr()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name" ></i></button>

            <div class="panel" [class]="panel_cls">
              <p>1. Enter your ITI Code and No. of Candidates to generate Bill Reference.
            </p>
            </div>

            <button class="accordion">Step 2 <i (click)="down_arr_2()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_2" aria-hidden="true"></i> <i (click)="up_arr_2()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_2" ></i></button>
            <div class="panel" [class]="panel_cls_2">
              <p>2. After generation, proceed to pay and get the receipt through Email from CCAvenue.</p>
            </div>


            <button class="accordion">Step 3 <i (click)="down_arr_3()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_3" aria-hidden="true"></i> <i (click)="up_arr_3()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_3" ></i></button>
            <div class="panel" [class]="panel_cls_3">
              <p>3. Wait for Successful payment. Please get confirmation mail from CCAvenue.</p>
            </div>

            <button class="accordion">Step 4 <i (click)="down_arr_4()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_4" aria-hidden="true"></i> <i (click)="up_arr_4()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_4" ></i></button>
            <div class="panel" [class]="panel_cls_4">
              <p>4. Go to CHECK PREVIOUS PAYMENTS STATUS link above and check for the Payment Reference marked as PAID.
                Cick the link to Update list and select the Roll Numbers for adding list.
                DO-NOT select wrong roll numbers, as once updated, it cannot be changed.
                </p>
            </div>

        </div>
    </div> -->

    <div class="row pad_size_cls ">
        <div class="col-md-12">
            <h3>Payment Related</h3>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <button class="accordion">1. I am getting a Transaction declined message?                <i (click)="down_arr_5()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_5" aria-hidden="true"></i> <i (click)="up_arr_5()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_5" ></i></button>

            <div class="panel" [class]="panel_cls_5">
              <p>Ans: kindly try from another instrument (card or payment method). You could have entered the wrong PIN also.
            </p>
            </div>

            <button class="accordion">2. Illegal Access detected, message is shown, what should I do? <i (click)="down_arr_6()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_6" aria-hidden="true"></i> <i (click)="up_arr_6()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_6" ></i></button>
            <div class="panel" [class]="panel_cls_6">
              <p>Ans: i) Check email ID, whether it is in the correct format. The email ID should not contain spaces in between or at the end.
                ii) Check Mobile number, no text characters are allowed.</p>
            </div>


            <button class="accordion">3. OOPS error message is showing, how to pay? <i (click)="down_arr_7()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_7" aria-hidden="true"></i> <i (click)="up_arr_7()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_7" ></i></button>
            <div class="panel" [class]="panel_cls_7">
              <p>Ans: It means that there are Invalid Characters in the address, state, city field, like brackets etc. Remove it and retry paying.</p>
            </div>

            <button class="accordion">4. Security error is showing up, what is the reason? <i (click)="down_arr_8()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_8" aria-hidden="true"></i> <i (click)="up_arr_8()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_8" ></i></button>
            <div class="panel" [class]="panel_cls_8">
              <p>Ans: Your card may be a Blocked card, try from another instrument.</p>
            </div>

            <button class="accordion">5. I have not recived my payment recipt ? <i (click)="down_arr_9()" class="fa fa-angle-down arrow_cls" [class]="up_arrow_cls_name_9" aria-hidden="true"></i> <i (click)="up_arr_9()" class="fa fa-angle-up arrow_cls" aria-hidden="true"  [class]="down_arrow_cls_name_9" ></i></button>
            <div class="panel" [class]="panel_cls_9">
              <p>Ans: Go to <a routerLink="/priForm"> nimionlineadmission.in/dgt/#/priForm </a> and raise grievence you will get a reply of your payemnt status if your payemnt status is verified, your recipt will be generated with in one or two days.</p>
            </div>

        </div>
    </div>
</div>




<style>

.banner_header{
        background: #2955a9;
    padding: 10px 0px;
    text-align: left;
    color: #fff;
    margin: 0px;
    }
    .banner_header h2{
        font-size: 21px;
    }

    .accordion {
      background-color: #eee;
      color: #444;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      border: none;
      text-align: left;
      outline: none;
      font-size: 15px;
      transition: 0.4s;
      position: relative;
    }

    .active, .accordion:hover {
      background-color: #ccc;
    }

    .panel {
      padding: 0 18px;
      display: none;
      background-color: white;
      overflow: hidden;
    }
    .panel p{
        padding: 10px 0px 0px;
    }
    .panel.hide{
        display: none;
    }
    .panel.show{
        display: block;
        text-align: left;
    }
    .arrow_cls{
        position: absolute;
        right: 15px;
        font-size: 21px;
        font-size: 21px;
    }
    .arrow_cls.hide{
        display: none;
    }
    .download_section{
        padding: 40px 0px;
        text-align: center;
    }
    .pad_size_cls{
        padding: 30px 0px;
    }
    </style>
